import React from "react";
import VendorPOProposalList from "../components/VendorPOProposalList";

const VendorDetailsSection = ({
  requestId,
  requestStatus,
  approvalHistory,
  onStatusChange,
}) => {
  // This is a wrapper to allow easy reuse in forms/pages
  return (
    <VendorPOProposalList
      requestId={requestId}
      requestStatus={requestStatus}
      approvalHistory={approvalHistory}
      onStatusChange={onStatusChange}
    />
  );
};

export default VendorDetailsSection;
